import {
  CREATE_INTERNATIONAL_METER_READING,
  DELETE_INTERNATIONAL_METER_READING,
  EDIT_INTERNATIONAL_METER_READING,
  RECEIVE_INTERNATIONAL_METER_READINGS,
  REQUEST_INTERNATIONAL_METER_READING,
  REQUEST_INTERNATIONAL_METER_READINGS_FOR_SITE,
  REQUEST_INTERNATIONAL_METER_READINGS_FOR_SITE_WITH_RANGE,
} from '@sophocles/entities/InternationalMeterReading/internationalMeterReadingActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_INTERNATIONAL_METER_READINGS: // Read
      return state.merge(action.internationalMeterReadings);
    case DELETE_INTERNATIONAL_METER_READING: // Delete
      return state.delete(action.internationalMeterReading.toString());
    case EDIT_INTERNATIONAL_METER_READING: // Update
    case CREATE_INTERNATIONAL_METER_READING: // Create
    case REQUEST_INTERNATIONAL_METER_READING:
    case REQUEST_INTERNATIONAL_METER_READINGS_FOR_SITE:
    case REQUEST_INTERNATIONAL_METER_READINGS_FOR_SITE_WITH_RANGE:
    default:
      return state;
  }
}

export function internationalMeterReadingReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_INTERNATIONAL_METER_READING:
    case DELETE_INTERNATIONAL_METER_READING:
    case RECEIVE_INTERNATIONAL_METER_READINGS:
    case EDIT_INTERNATIONAL_METER_READING:
    case REQUEST_INTERNATIONAL_METER_READING:
    case REQUEST_INTERNATIONAL_METER_READINGS_FOR_SITE:
    case REQUEST_INTERNATIONAL_METER_READINGS_FOR_SITE_WITH_RANGE:
      return getState(state, action);
    default:
      return state;
  }
}
